<template>
  <div class="NewsAndMediaConfig LocalConfig d-none" aria-hidden="true" />
</template>

<script>
import { castPropToType } from '@/helpers/cms-support';

export default {
  name: 'NewsAndMediaConfig',
  props: {
    dataConfig: {
      type: [Object, String],
      required: true,
    },
  },
  setup() {
    return { castPropToType };
  },
  computed: {
    config() {
      return this.dataConfig
        ? this.castPropToType(this.dataConfig, 'object')
        : null;
    },
  },
  mounted() {
    this.$store.dispatch('setProperties', {
      module: 'newsAndMedia',
      payload: this.config,
    });
  },
};
</script>

<style lang="scss" scoped></style>
